export enum TestAnswerStatusEnum {
  InProgress = "in_progress",
  Done = "done",
}
